module.exports = __webpack_public_path__ + "static/media/tailwind.e90ad25f.svg";